import styled from "styled-components";

export const CustomersContainer = styled.section`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  /* height: 289px; */
`;

export const CustomersLogoContainer = styled.div`
  width: 70%;
  padding-top: 4.8rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  @media (max-width: 600px) {
    padding-top: 4rem;
  }
  @media (max-width: 1150px) {
    width: 100%;
  }
`;

export const ImgWrapper = styled.div`
  height: 100px;
  width: 19%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  filter: blur(1px);
  filter: grayscale(1);
  &:hover {
    filter: blur(0px);
    scale: 1.1;
    filter: grayscale(0);
  }
  &:nth-child(3) a:hover svg path {
    fill: #12a46f;
    stroke: #12a46f;
  }
  & a {
    transition: 0.5s;
    img {
      width: 115px;
    }
    &:hover svg path {
      fill: #12a46f;
    }
  }
  @media (max-width: 1024px) {
    width: 42%;
  }
`;

export const CustomWrapper = styled.div`
  padding: 40px 0;
  /* background-color: var(--card-bg-color); */
  background: #f3f3f3;
  mix-blend-mode: normal;
`;

export const TextContainer = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};
  margin-top: 1.2rem;
  p {
    font-weight: 700;
    font-family: Peyda;
    font-size: 3.2rem;
    line-height: 5.6rem;
    color: var(--white-color);
    @media (max-width: 768px) {
      font-size: 1.4rem;
      line-height: 2rem;
    }
  }
`;

export const TitleContainer = styled.div`
  width: ${(props) => props.width || "23%"};
  position: relative;

  span {
    display: inline-block;
    width: 11.11px;
    height: 21px;
    position: absolute;
    top: 52px;
    left: 98%;
    background-color: ${(props) => props.color || "#fff"};
  }
  h5 {
    font-size: 1.6rem;
    font-weight: 800;
    color: ${(props) => props.titleColor || "#FFFFFF"};
    opacity: ${(props) => props.opacity || "1"};
    margin-bottom: 0.6rem;
    font-family: Peyda;
  }
  p {
    font-size: 3.2rem;
    font-weight: 700;
    line-height: 5.3rem;
    padding-right: 1.4rem;
    color: ${(props) => props.textColor || "#FFFFFF"};
    @media (max-width: 850px) {
      font-size: 2.6rem;
    }
    @media (max-width: 600px) {
      font-size: 2.2rem;
    }
  }

  @media (max-width: 1471px) {
    width: ${(props) => props.width1471 || "80%"};
  }
  @media (max-width: 1151px) {
    width: ${(props) => props.width1151 || "100%"};
  }
  @media (max-width: 600px) {
    width: ${(props) => props.width600 || "468px"};
  }
  @media (max-width: 580px) {
    width: ${(props) => props.width600 || "100%"};
  }
`;
